import React, { Component } from 'react';
import { TableDefault } from '../../../../../components';
import { Breadcrumb } from '../../../../../components';

class List extends Component {
  constructor(props) {
    super(props);

    this.state = {
      search: '',
      pageSize: 100,
      totalItems: 0,
      orderBy: 'Descricao',
      order: '',
      urlEdit: '/admin/gestao/segmentos/',
      urlLoad: '/Segmentos/GetListagem/',     
    };
  }

  componentWillMount = () => {

  };

  novo = () => {
    const { history } = this.props;
    history.push('/admin/Segmento/0');
  };

  render() {
    const {
      page,
      pageSize,
      totalItems,
      search,
      order,
      orderBy,
      urlEdit,
      urlLoad,
      actions,
    } = this.state;

      const { type, defaultFilters } = this.props;
      return (
        <div>
          <Breadcrumb
            title="Segmentos"
            description="Gerencie os segmentos."
            renderRight={(() => (
              <div className="breadcrumb-right-actions">
                <button
                  type="button"
                  className="bx--btn btn-secondary-color v-md-margin"
                  onClick={this.novo}
                >
                  Cadastrar
                </button>
              </div>
            ))()}
          />
          <section className="content-wrapper">
            <div className="segmentos-list">
              <TableDefault
                search={search}
                type={type}
                order={order}
                orderBy={orderBy}
                defaultFilters={defaultFilters}
                extraRows={actions}
                page={page}
                pageSize={pageSize}
                totalItems={totalItems}
                // urlDelete={urlDelete}
                urlEdit={urlEdit}
                urlLoad={urlLoad}
              />
            </div>
          </section>
        </div>
      );
    }
  }
  
  export default List;


// WEBPACK FOOTER //
// ./src/screens/admin/Gestao/Segmentos/List/List.jsx